module.exports = __webpack_public_path__ + "static/media/thumbnail.6b98d097.jpg";